import React, { memo } from 'react'
import map from 'ramda/src/map'
import DropsEventItem from 'root/src/client/web/list/listItemComponents/dropEvent/DropEventCard'
import classNames from 'classnames'
import LoadingProgress from 'root/src/client/web/list/LoadingProgress'
import SubTitle from 'root/src/client/web/typography/SubTitle'
import withStyles from '@material-ui/core/styles/withStyles'
import { trackWindowScroll } from 'react-lazy-load-image-component'

import InfiniteScroller from 'root/src/client/web/list/util/InfiniteScroller'

import MaxWidthContainer from 'root/src/client/web/base/MaxWidthContainer'
import { RecordProvider } from 'root/src/client/web/contexts/recordContext'
import { cardListStyle } from './style'

const DropsEventList = memo(({
	list, currentPage, hasMore, classes, getNextPage,
	moduleId, pageItemLength, pageItemsCount, visibleLoadingBlock, listSubtitle,
}) => (
	<MaxWidthContainer>
		{listSubtitle && <SubTitle className={classes.subtitle}>{listSubtitle}</SubTitle>}
		{
			InfiniteScroller({
				currentPage,
				hasMore,
				getNextPage,
				moduleId,
				pageItemLength,
				pageItemsCount,
			})(
				<div
					className={classNames(
						classes.paddingOffset,
						'layout-row layout-wrap',
					)}
				>
					{map(recordId => (
						<RecordProvider key={recordId} recordId={recordId}>
							<DropsEventItem
								key={recordId}
								recordId={recordId}
							/>
						</RecordProvider>
					), list)}
					<LoadingProgress loading={visibleLoadingBlock} />
				</div>,
			)}
	</MaxWidthContainer>
))

export default withStyles(cardListStyle, { name: 'MuiCardList' })(trackWindowScroll(DropsEventList))
